import React from "react";
import Table from "@mui/material/Table";
import { Email, Textsms  } from "@mui/icons-material";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import IconButton from "@mui/material/IconButton";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableContainer from "@mui/material/TableContainer";
import LinearProgress from '@mui/material/LinearProgress';
import TablePagination from "@mui/material/TablePagination";
import { SIZES, SORT_ORDERS, ALIGN, HTML_TAGS } from "../../common/constants/commonConstants.js";
import { CUSTOMER_TABLE_COLUMN_KEYS, CUSTOMER_MESSAGES } from "../../common/constants/customerModule/customerConstants.js";

const CustomersConvTable = ({
    page,
    order,
    setPage,
    orderBy,
    campaigns,
    rowsPerPage,
    customers,
    setRowsPerPage,
    columns,
    onEmail,
    onText,
    handleRequestSort,
    isCustomersLoading,
    isCampaignsLoading,
    filteredCustomersLength
}) => {

    return (
        <>
            <TableContainer sx={{ mt: 2 }}>
                <Table size={SIZES.SMALL}>
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    sortDirection={orderBy === column.id ? order : false}
                                    align={
                                        column.id === CUSTOMER_TABLE_COLUMN_KEYS.CUSTOMER_ID
                                            ? ALIGN.CENTER
                                            : ALIGN.LEFT
                                    }
                                    sx={{
                                        width:
                                            column.id === CUSTOMER_TABLE_COLUMN_KEYS.ACTIONS ? 60 :
                                            column.id === CUSTOMER_TABLE_COLUMN_KEYS.CUSTOMER_ID ? 75 :
                                            column.id === CUSTOMER_TABLE_COLUMN_KEYS.CUSTOMER_NAME ? 150 :
                                            column.id === CUSTOMER_TABLE_COLUMN_KEYS.EMAIL ? 150 :
                                            column.id === CUSTOMER_TABLE_COLUMN_KEYS.PHONE ? 100 :
                                            column.id === CUSTOMER_TABLE_COLUMN_KEYS.CAMPAIGN ? 150 : 200,
                                    }}
                                >
                                    {column.isSortable ? (
                                        <TableSortLabel
                                            active={orderBy === column.id}
                                            direction={orderBy === column.id ? order : SORT_ORDERS.ASCENDING}
                                            onClick={() =>
                                                handleRequestSort(column.id)
                                            }
                                        >
                                            {column.label}
                                        </TableSortLabel>
                                    ) : column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isCustomersLoading || isCampaignsLoading ? (
                            <TableRow>
                                <TableCell colSpan={columns.length} align={ALIGN.CENTER} >
                                    <LinearProgress />
                                </TableCell>
                            </TableRow>
                        ) : customers.length > 0 ? customers.map((customer) => (
                            <TableRow hover tabIndex={-1} key={customer.id}>
                                <TableCell>
                                    <IconButton onClick={() => onEmail(customer)}>
                                        <Email fontSize={SIZES.SMALL} />
                                    </IconButton>
                                    <IconButton onClick={() => onText(customer)}>
                                        <Textsms fontSize={SIZES.SMALL} />
                                    </IconButton>
                                </TableCell>
                                <TableCell align={ALIGN.CENTER}>
                                    {customer.customerid ? customer.customerid : "-"}
                                </TableCell>
                                <TableCell>
                                    {customer.name}
                                </TableCell>
                                <TableCell>
                                    {customer.emailaddress}
                                </TableCell>
                                <TableCell>
                                    {customer.customeruniqueid.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")}
                                </TableCell>
                                <TableCell>
                                    {campaigns.find(campaign => campaign.id === customer.campaignid)?.name || "-"}
                                </TableCell>
                            </TableRow>
                        )) : (
                            <TableRow>
                                <TableCell colSpan={columns.length} align={ALIGN.CENTER}>
                                    {CUSTOMER_MESSAGES.NO_CUSTOMERS}
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                <TablePagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    component={HTML_TAGS.DIV}
                    count={filteredCustomersLength}
                    rowsPerPageOptions={[10, 25, 50]}
                    onPageChange={(event, newPage) => setPage(newPage)}
                    onRowsPerPageChange={(event) => {
                        setPage(0);
                        setRowsPerPage(parseInt(event.target.value, 10));
                    }}
                />
            </TableContainer>
        </>
    )
};

export default CustomersConvTable;